import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { ToastProvider } from './components/ui/toaster';
import App from './App';

// Facebook SDK types
declare global {
    interface Window {
        FB: {
            init: (config: { appId: string; version: string; xfbml?: boolean; cookie?: boolean }) => void
            login: (callback: (response: any) => void, options?: any) => void
            getLoginStatus: (callback: (response: any) => void) => void
        }
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            retry: 1,
        },
    },
});

export default function Root() {
    // Initialize Facebook SDK
    useEffect(() => {
        const initFacebookSDK = () => {
            if (window.FB) {
                try {
                    window.FB.init({
                        appId: '1437201993807445',
                        version: 'v24.0',
                        xfbml: true,
                        cookie: true,
                    });
                    console.log('Facebook SDK initialized');
                } catch (error) {
                    console.error('Error initializing Facebook SDK:', error);
                }
            }
        };

        // Check if SDK is already loaded
        if (window.FB) {
            initFacebookSDK();
        } else {
            // Wait for SDK to load
            const checkInterval = setInterval(() => {
                if (window.FB) {
                    clearInterval(checkInterval);
                    initFacebookSDK();
                }
            }, 100);

            // Cleanup after 10 seconds
            setTimeout(() => {
                clearInterval(checkInterval);
            }, 10000);
        }
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <ToastProvider>
                    <App />
                </ToastProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </BrowserRouter>
        </QueryClientProvider>
    );
}
